import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { MazeScene } from "./MazeScene";
import { AudioManager } from "../../AudioManager";
import { MazeManager } from "./MazeManager";

export class PauseLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x131538, .65);
        darkLayer.setInteractive();
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const pauseTitle = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, 180 * GameVars.scaleY, "texture_atlas_2_" + GameVars.gameData.language, "text_pause");
        pauseTitle.scaleY = GameVars.scaleY;
        pauseTitle.setOrigin(.5);
        this.add(pauseTitle);

        this.scene.tweens.add({
            targets: [pauseTitle],
            alpha: 0.7,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 500,
            yoyo: true,
            repeat: -1
        });

        const pauseButton = new Button(this.scene, GameConstants.GAME_WIDTH - 30 * GameVars.correctionScale, 30 * GameVars.scaleY * GameVars.correctionScale, "texture_atlas_1", "btn_resume_off", "btn_resume_on");
        pauseButton.setInflationTween(1.1 * GameVars.correctionScale, 1 * GameVars.correctionScale, GameVars.scaleY * GameVars.correctionScale);
        pauseButton.onUp(this.onClickResume, this);
        pauseButton.setScrollFactor(0);
        this.add(pauseButton);

        const restartButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .5, "texture_atlas_2_" + GameVars.gameData.language, "btn_restart_off", "btn_restart_on");
        restartButton.setOrigin(.5);
        restartButton.setInflationTween(1.1, 1, GameVars.scaleY);
        restartButton.onUp(this.onRestart, this);
        this.add(restartButton);

        this.createSoundButton();

        const exitButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .5 + 180 * GameVars.scaleY, "texture_atlas_2_" + GameVars.gameData.language, "btn_exit_game_off", "btn_exit_game_on");
        exitButton.setOrigin(.5);
        exitButton.setInflationTween(1.1, 1, GameVars.scaleY);
        exitButton.onUp(this.onExit, this);
        this.add(exitButton);
    }

    private createSoundButton(): void {

        const xOffset = 26;

        let audioLabelText: string;
        if (GameVars.gameData.muted) {
            audioLabelText = GameVars.languages[GameVars.gameData.language]["SOUND OFF"];
        } else {
            audioLabelText = GameVars.languages[GameVars.gameData.language]["SOUND ON"];
        }

        let audioButtonFrame: string;
        if (GameVars.gameData.muted) {
            audioButtonFrame = "btn_switch_off_off";
        } else {
            audioButtonFrame = "btn_switch_on_off";
        }

        const audioButton = new Phaser.GameObjects.Image(this.scene, xOffset + GameConstants.GAME_WIDTH / 2 + 40, GameConstants.GAME_HEIGHT * .5 + 90 * GameVars.scaleY, "texture_atlas_1", audioButtonFrame);
        audioButton.setOrigin(.5);
        audioButton.scaleY = GameVars.scaleY;
        audioButton.setInteractive();
        this.add(audioButton);

        const audioLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, audioLabelText, { fontFamily: "Sarpanch-Black", fontSize: "20px", color: "#FFFFFF" });
        audioLabel.setOrigin(1, .5);
        audioLabel.x = audioButton.x - (audioButton.width * .5) * 1.1;
        audioLabel.y = audioButton.y;
        this.add(audioLabel);

        audioButton.on("pointerover", function (): void {
            audioButton.setTexture("texture_atlas_1", GameVars.gameData.muted ? "btn_switch_off_on" : "btn_switch_on_on");
            audioButton.setScale(1.1, GameVars.scaleY * 1.1);
            audioLabel.setText(GameVars.gameData.muted ? GameVars.languages[GameVars.gameData.language]["SOUND OFF"] : GameVars.languages[GameVars.gameData.language]["SOUND ON"]);
        }, this);
        audioButton.on("pointerout", function (): void {
            audioButton.setTexture("texture_atlas_1", GameVars.gameData.muted ? "btn_switch_off_off" : "btn_switch_on_off");
            audioButton.setScale(1, GameVars.scaleY);
            audioLabel.setText(GameVars.gameData.muted ? GameVars.languages[GameVars.gameData.language]["SOUND OFF"] : GameVars.languages[GameVars.gameData.language]["SOUND ON"]);
        }, this);
        audioButton.on("pointerup", function (): void {
            audioButton.setTexture("texture_atlas_1", GameVars.gameData.muted ? "btn_switch_off_off" : "btn_switch_on_off");
            if (this.scene.game.device.os.desktop) {
                audioButton.setScale(1.1, GameVars.scaleY * 1.1);
            } else {
                audioButton.setScale(1, GameVars.scaleY * 1);
            }
            audioLabel.setText(GameVars.gameData.muted ? GameVars.languages[GameVars.gameData.language]["SOUND OFF"] : GameVars.languages[GameVars.gameData.language]["SOUND ON"]);
        }, this);
        audioButton.on("pointerdown", function (): void {
            audioButton.setTexture("texture_atlas_1", GameVars.gameData.muted ? "btn_switch_off_on" : "btn_switch_on_on");
            if (this.scene.game.device.os.desktop) {
                audioButton.setScale(1, GameVars.scaleY * 1);
            } else {
                audioButton.setScale(1.1, GameVars.scaleY * 1.1);
            }
            this.onClickAudioButton();
            audioLabel.setText(GameVars.gameData.muted ? GameVars.languages[GameVars.gameData.language]["SOUND OFF"] : GameVars.languages[GameVars.gameData.language]["SOUND ON"]);
        }, this);
    }

    private onRestart(): void {

        AudioManager.playSound("click");

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "Reset";
            } else {
                GameManager.enterMazeScene();
            }
        } else {
            GameManager.enterMazeScene();
        }
    }

    private onExit(): void {

        AudioManager.playSound("click");

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "MainMenu";
            } else {
                GameManager.enterSplash();
            }
        } else {
            GameManager.enterSplash();
        }
    }

    private onClickResume(): void {

        MazeManager.resumeGame();

        AudioManager.playSound("click");
    }

    private onClickAudioButton(): void {

        AudioManager.toggleAudioState();
    }
}
